import React from 'react'
import numeral from 'numeral'
import { NumberType } from '@api'

interface PrettyNumberProps {
  value: number | string
  numberType?: NumberType
  numeralFormat?: string
  'data-input'?: string
}

function getFormat(numberType?: NumberType): string {
  switch (numberType) {
    case NumberType.ROUNDED_DOLLAR:
      return '$0,0[.]0a'
    case NumberType.ROUNDED_NUMBER:
      return '0,0[.]0a'
    case NumberType.DOLLAR:
      return '$0,0[.]00'
    case NumberType.NUMBER:
    default:
      return '0,0[.]00'
  }
}

export function prettyNumber({ value, numberType, numeralFormat }: PrettyNumberProps) {
  return numeral(value).format(numeralFormat || getFormat(numberType))
}

/**
 * <Number value={1000} /> => <span>1,000<span>
 * <Number value={'1000'} round /> => <span>1k</span>
 */
export default function PrettyNumber(props: PrettyNumberProps) {
  return <span data-input={props['data-input']}>{prettyNumber(props)}</span>
}

export function PrettyDollar(props: PrettyNumberProps) {
  return (
    <span data-input={props['data-input']}>
      {prettyNumber({ ...props, numberType: NumberType.DOLLAR })}
    </span>
  )
}
